import { staticConfig } from "@fidget/common/config/static-config";

export interface TemplatePair {
  key: string;
  value: string;
}
export interface Tag {
  opening: string;
  closing: string;
}

export const templateTagging = (text: string, raw: Tag, compiled: Tag): TemplatePair => ({
  key: raw.opening + text + raw.closing,
  value: compiled.opening + text + compiled.closing
});

const { templates, rawTag, compiledTag } = staticConfig;

export const templatePairs = templates.map((template) =>
  templateTagging(template, rawTag, compiledTag)
);

export const replaceText = (text: string, replacers: TemplatePair[], swap?: boolean) =>
  replacers.reduce(
    (replacedText, replacer) =>
      replacedText.replace(
        swap ? new RegExp(replacer.value, "g") : new RegExp(replacer.key, "g"),
        swap ? replacer.key : replacer.value
      ),
    text
  );
